import { IsConnectedResponse, SuccessResponse, WorkspaceIdRequest } from '../request-response';
import { ResourceName } from '../resource-name';

export const UnipileGate = {
  resource: ResourceName.unipile,
  actions: {
    isConnected: 'is-connected',
    sendInvitation: 'send-invitation',
    sendSecondMessage: 'send-second-message',
    getMessageListByChatId: 'get-message-list-by-chat-id',
  },
};

export type UnipileGateActionTypes = {
  isConnected: {
    request: WorkspaceIdRequest;
    response: IsConnectedResponse;
  };
  sendInvitation: {
    request: UnipileSendInvitationRequest;
    response: SuccessResponse;
  };
  sendSecondMessage: {
    request: UnipileSendMessageRequest;
    response: any;
  };
  getMessageListByChatId: {
    request: {
      chatId: string;
    };
    response: any;
  };
};

export interface UnipileSendMessageRequest {
  workspaceId: string;
  leadsId: string;
}

export interface UnipileSendInvitationRequest {
  workspaceId: string;
  leadsId: string;
}
